import { render } from "./ForeignView.vue?vue&type=template&id=7b8dd62e&ts=true"
import script from "./ForeignView.vue?vue&type=script&lang=ts"
export * from "./ForeignView.vue?vue&type=script&lang=ts"

import "./ForeignView.vue?vue&type=style&index=0&id=7b8dd62e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__